import type { FeatureRoutes } from '@/app/screens'

export default {
  screens: { coaching: () => import('./CoachingPage.vue') },
  routes: [{
    path: '/coaching/plans/:id',
    component: () => import('./PlanPage.vue'),
    meta: { perm: 'coaching.view', navKey: 'coaching' },
  }],
} satisfies FeatureRoutes
